import React, { FC, memo, useCallback } from 'react';
import classNames from 'classnames';
import './style.scss';

interface IProps {
  label: string;
  value: number;
  active: boolean;
  onClick: (value: number) => void;
}

const PaginationPageButton: FC<IProps> = ({ label, value, active, onClick }: IProps): JSX.Element | null => {
  const handleChange = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  const className = classNames('pagination__button', {
    pagination__button_active: active,
  });

  return (
    <button className={className} onClick={handleChange}>
      {label}
    </button>
  );
};

export default memo(PaginationPageButton);
